<template>
  <v-container class="p-pay">
    <v-layout class="mt-2">
      <v-flex grow>
        <CSection title="支付">
            <h3>基本信息</h3>
          <v-layout>
            <v-flex>
              <p class="introduce-text my-3">订单号：{{orderParam.orderCode}}</p>
              <p class="introduce-text">应付保费：<span class="money">￥{{orderParam.amount}}</span></p>
            </v-flex>
          </v-layout>
        <h3 class="mt-4 mb-3 down-title">
        <img src="https://qihuibao.oss-cn-beijing.aliyuncs.com/aig/downLogo.png" alt="">
        线下公对公转账
        </h3>
          <p class="introduce-text attention blink">注意事项：线下全部要公对公转账，除个体工商户法人账户转账之外，<span style="font-size:16px;font-weight: bold">不接受其他个人转账情形，如遇个人账号，则全部退回保费</span></p>
        </CSection>
      </v-flex>
    </v-layout>
    <v-layout class="mt-4">
      <v-flex grow>
        <CSection>
          <h3 class="mt-4 mb-3">汇款信息</h3>
          <v-layout class="group">
            <v-flex>
              <p class="introduce-text"><span class="info-pay">收款账户名称</span>：美亚财产保险有限公司北京分公司</p>
              <p class="introduce-text"><span class="info-pay">纳税人识别号</span>：9111010568510352X0</p>
              <p class="introduce-text"><span class="info-pay">地址、电话</span>：北京市朝阳区建国路79号10层10办公2T01内05，06室 4008208858</p>
              <p class="introduce-text"><span class="info-pay">开户行及账号</span>：招商银行光华路支行 110906387910601</p>
            </v-flex>
          </v-layout>
          <v-layout class="form-item-btn-mb">
            <v-flex class="form-item form-item-left">
                <CUpload
                class="form-item-btn-wrap"
                :on-success="onUploadSuccess"
                show-type="picture"
                :limit="1"
                >上传电子凭证</CUpload>
                <a class="primary-text mt-2" @click="sampleVisible = true">查看样例</a>
            </v-flex>
            </v-layout>
            <div style="text-align:right;margin-top:10px">
                <v-btn v-if="!isBq" large color="primary" @click="submit" :loading="subLoading">提交</v-btn>
                <v-btn v-else large color="primary" @click="bqSub" :loading="subLoading">提交</v-btn>
            </div>
          <div style="padding: 20px 0">
            温馨提示：上传电子凭证并提交后，由美亚财险后援中心同事确认保费是否到帐，并完成承保确认生成保单，<strong>目前当天下午3点前发送的邮件可以当天完成确认，3点以后发送到需要T+1个工作日；</strong>
          </div>
        </CSection>
      </v-flex>
    </v-layout>
  <v-dialog v-model="sampleVisible" width="500">
    <v-card>
      <v-img src="https://qihuibao.oss-cn-beijing.aliyuncs.com/aig/card.jpg"></v-img>
    </v-card>
  </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
        subLoading:false,
        sampleVisible:false,
        businessLicenseFile:null,
        orderParam:{},
        isBq:false
    };
  },
  created() {
    this.orderParam = JSON.parse(window.atob(this.$route.query.param))
    if(this.orderParam.from){
        this.isBq = true
    }
    console.log(this.orderParam)
  },
  methods: {
    bqSub(){
        this.subLoading = true
        let formData = new FormData();
        formData.append("endorsementCode", this.orderParam.orderCode);
        formData.append("file", this.businessLicenseFile);
        this.$axios.post('/app/api/heshunbao/confirmEndorsement',formData).then(res=>{
            if(res.code == 200){
                this.$message.success(res.message)
                this.subLoading = false
                this.$router.push('/orderInsure')
            }
        }).catch(val=>{
            this.subLoading = false
            this.$message.error(val.message)
        })
    },
    submit(){
        this.subLoading = true
        let formData = new FormData();
        formData.append("orderCode", this.orderParam.orderCode);
        formData.append("file", this.businessLicenseFile);
        this.$axios.post('/app/api/heshunbao/b/confirmPolicy',formData).then(res=>{
            if(res.code == 200){
                this.$message.success(res.message)
                this.subLoading = false
                this.$router.push('/order')
            }
        }).catch(val=>{
            this.subLoading = false
            this.$message.error(val.message)
        })
    },
    onUploadSuccess(file) {
      this.businessLicenseFile = file;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/var";
.money{
    color: $primary-color;
    font-size: 20px;
    font-weight: bold;
}
.primary-text{
    margin-left: 10px;
    margin-top: 13px!important;
    font-size: 14px!important;
}
.info-pay{
    width: 90px;
    display: inline-block;
}
.down-title{
    color: #7f7f7f;
    img{
        width: 40px;
        height: 40px;
        margin-right: 10px;
        vertical-align: middle;
    }
}
.attention{
    color: #d9001b99;
}
.p-pay {
  .group {
    &-item {
      width: 225px;
      height: 57px;
      border: 1px solid $explain-color;
      flex: none;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      cursor: pointer;
      &-img {
        width: 126px;
        height: 45px;
      }
      &-checked {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 24px;
      }
    }
  }
  .pay-btn{
    width: 240px;
    height: 50px;
    margin-left: 0;
  }
  .border-selected{
      border:1px solid $primary-color !important;
  }
  @keyframes blink{
    0% {opacity: 1;}
    33% {opacity: 1;color: red}
    66% {opacity: 1;color: green}
    100% {opacity: 1;color: blue}
  }
  .blink{
    animation: blink 1s linear infinite;
  }
}
</style>

